import { FC } from 'react';

import { VoucherSummary } from '@/api/voucher/voucher.types.ts';
import eyeIcon from '@/assets/eyeIcon.png';
import { capitalizeText } from '@/utils/valueFormatter.ts';

type Props = {
  voucher: VoucherSummary;
  selectedVouchers: string[];
  isCorporateUser: boolean;
  onSelectVoucher: (voucherId: string, isSelected: boolean) => void;
  onView: (voucher: VoucherSummary) => void;
};

const VoucherRow: FC<Props> = ({
  voucher,
  selectedVouchers,
  isCorporateUser,
  onSelectVoucher,
  onView,
}) => {
  const isSelected = selectedVouchers.includes(voucher.id);

  const getStatusClasses = (status: string): string => {
    switch (status) {
      case 'active':
        return 'text-vouchersGreen';
      case 'redeemed':
        return 'text-vouchersRed';
      case 'expired':
        return 'text-vouchersRed';
      default:
        return 'text-gray-600';
    }
  };

  return (
    <tr className="hover:bg-gray-50 transition-colors">
      <td className="px-4 py-3">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => onSelectVoucher(voucher.id, !isSelected)}
          aria-label={`Select voucher ${voucher.code}`}
          className="h-4 w-4 text-honoursOrange border-honoursOrange rounded focus:ring-honoursOrange cursor-pointer"
          style={{
            accentColor: '#FDA602',
          }}
        />
      </td>
      <td className="px-4 py-3" aria-hidden="true" />
      <td
        className="px-4 py-3 text-sm text-gray-500 pl-12"
        aria-hidden="true"
      />
      <td className="px-4 py-3 text-sm text-gray-900">{voucher.code}</td>
      <td className="px-4 py-3 text-sm">
        <span className={getStatusClasses(voucher.status)}>
          {capitalizeText(voucher.status)}
        </span>
      </td>
      {!isCorporateUser && (
        <>
          <td className="px-4 py-3 text-sm text-gray-900" aria-hidden="true" />
          <td className="px-4 py-3 text-sm text-gray-900" aria-hidden="true" />
        </>
      )}
      <td className="px-4 py-3 text-sm text-gray-900" aria-hidden="true" />
      <td className="px-4 py-3 text-sm text-gray-900" aria-hidden="true" />
      <td className="px-4 py-3 text-sm flex justify-center">
        <img
          src={eyeIcon}
          alt="View details"
          className="h-4 w-auto cursor-pointer hover:opacity-70 transition-opacity"
          onClick={() => onView(voucher)}
        />
      </td>
    </tr>
  );
};

export default VoucherRow;
